module.exports = __webpack_public_path__ + "img/left_right_layout_1.4d967fed.svg";